/* Afroyla LAST PIECES — the shelf under "Last in the box", all from the inline live data (window.ALP). Port of the
 * Lettoria Odd Lot shelf (10-16):
 *  · one grid in COLLECTION ORDER (ops manual sort: odd lots first, then wallet → small bag → bag interleaved), 24 per page + "Show more"
 *  · odd-lot items currently in Last in the box are left out (they live up there); "Only N left" only for lp-odd-lot (brief §4)
 *  · bag cards "+ wallet $9.95", wallet cards "$13.95 · $9.95 with any bag" (brief §4)
 *  · "Already gone today" small GONE thumbnails of anything sold out (removed from the grid, kept visible at the bottom)
 * Chips = brief §4 tabs, priciest first, with live "from $" prices. Re-renders on 'alp:data'. Needs window.ALP. */
(function () {
  var A = window.ALP;
  if (!A) return;
  var root = A.root;
  var gridEl = root.querySelector('[data-alp-grid]'), moreBtn = root.querySelector('[data-alp-more]');
  var goneEl = root.querySelector('[data-alp-gone]'), chipsEl = root.querySelector('[data-alp-chips]');
  if (!gridEl) return;
  var PAGE = 24;
  var CHIPS = [ // brief §4 tabs, priciest first (Afroyla 10-14: "anchor value, not floor"); g from lp-type-* (product-data snippet)
    { key: 'bag', name: 'Handbags, Totes & Backpacks', test: function (d) { return d.g === 'bag'; } },
    { key: 'small', name: 'Crossbody & Small Bags', test: function (d) { return d.g === 'small'; } },
    { key: 'wallet', name: 'Wallets & Makeup Bags', test: function (d) { return d.g === 'wallet'; } }
  ];
  var active = 'all', shown = PAGE, sig = '';
  function chipOf(key) { for (var k = 0; k < CHIPS.length; k++) if (CHIPS[k].key === key) return CHIPS[k]; return null; }
  function inChip(d) { var c = chipOf(active); return !c || c.test(d); }
  function inLd(d) { return A.inLightning ? A.inLightning(d.h) : false; }

  var wFrom = 0; // cheapest wallet with a bag (price − $4), set per render
  function card(d) {
    var off = A.pct(d.p, d.c);
    var left = d.s === 'odd' && d.q != null && d.q > 0;
    return '<article class="alp-card">' +
      '<a class="alp-card__media" href="/products/' + A.esc(d.h) + '" data-alp-quick="' + A.esc(d.h) + '" data-hc-el="card-quick-view">' +
        '<img src="' + A.esc(A.img(d.i, 500)) + '" alt="' + A.esc(d.t) + '" loading="lazy" width="500" height="400">' +
        (off ? '<span class="alp-badge">−' + off + '%</span>' : '') + '</a>' +
      '<div class="alp-card__body">' +
        '<h3 class="alp-card__title">' + A.esc(d.t) + '</h3>' +
        (d.m ? '<p class="alp-card__mat">' + A.esc(d.m) + '</p>' : '') +
        '<p class="alp-price"><b>' + A.money(d.p) + '</b>' + (d.c > d.p ? ' <s>' + A.money(d.c) + '</s>' : '') + '</p>' +
        (d.g === 'wallet' ? '<p class="alp-card__plus">' + A.money(d.p - 4) + ' with any bag</p>' : '') +
        (left ? '<p class="alp-left">Only ' + d.q + ' left</p>' : '') +
        (d.g !== 'wallet' && wFrom ? '<p class="alp-card__plus">+ wallet ' + A.money(wFrom) + '</p>' : '') + // brief §3
        '<button type="button" class="alp-btn alp-card__add" data-add="' + A.esc(d.h) + '" data-hc-el="card-add">Add · ' + A.money(d.p) + '</button>' +
      '</div></article>';
  }

  function paintChips(avail) {
    if (!chipsEl) return;
    var html = '<button type="button" class="alp-chip' + (active === 'all' ? ' is-on' : '') + '" data-chip="all" data-hc-el="chip-all">All</button>';
    CHIPS.forEach(function (c) {
      var ps = avail.filter(c.test).map(function (d) { return d.p; });
      if (!ps.length) return;
      var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);
      html += '<button type="button" class="alp-chip' + (active === c.key ? ' is-on' : '') + '" data-chip="' + c.key + '" data-hc-el="chip-' + c.key + '">' +
        c.name + ' · <span>' + (lo === hi ? '' : 'from ') + A.money(lo) + '</span></button>';
    });
    chipsEl.innerHTML = html;
  }

  function render(force) {
    var data = A.data();
    var s = data.map(function (d) { return d.h + d.a + d.q + inLd(d); }).join('|') + active + shown;
    if (!force && s === sig) return;
    sig = s;
    var avail = data.filter(function (d) { return d.a && !inLd(d); });
    var wp = data.filter(function (d) { return d.a && d.g === 'wallet'; }).map(function (d) { return d.p; });
    wFrom = wp.length ? Math.min.apply(null, wp) - 4 : 0;
    paintChips(avail);
    var list = avail.filter(inChip);
    gridEl.innerHTML = list.slice(0, shown).map(card).join('');
    if (moreBtn) {
      var rest = list.length - shown;
      moreBtn.hidden = rest <= 0;
      moreBtn.textContent = rest > PAGE ? 'Show ' + PAGE + ' more · ' + rest + ' more to browse' : 'Show the last ' + rest;
    }
    if (goneEl) {
      var gone = data.filter(function (d) { return !d.a; });
      goneEl.closest('[data-alp-gone-wrap]').hidden = !gone.length;
      goneEl.innerHTML = gone.map(function (d) {
        return '<div class="alp-gone__item"><div class="alp-gone__img"><img src="' + A.esc(A.img(d.i, 240)) + '" alt="' + A.esc(d.t) + '" loading="lazy" width="240" height="320">' +
          '<span class="alp-gone__stamp">GONE</span></div><span class="alp-gone__t">' + A.esc(d.t) + '</span></div>';
      }).join('');
    }
  }

  function setChip(key) {
    active = chipOf(key) ? key : 'all'; shown = PAGE; render(true);
    var top = root.querySelector('[data-alp-shelves]');
    if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-chip]');
    if (chip) { setChip(chip.dataset.chip); return; }
    if (e.target.closest('[data-alp-more]')) { shown += PAGE; render(true); return; }
    var add = e.target.closest('[data-add]');
    if (add) {
      var d = A.data().filter(function (x) { return x.h === add.dataset.add; })[0];
      if (d && d.a) A.runAdd(add, d);
    }
  });
  // lightning module is loaded first, so its 'alp:data' listener has already re-pooled when this one runs
  root.addEventListener('alp:data', function () { render(false); });
  render(true);
})();
